<template>
  <div class="f-console17-tabs">
    <f-project-tabs>
      <template #default>
        <f-project-tab
          v-for="item in items"
          :key="item.title"
          :title="$vt(item.title)"
          :icon="item.icon"
          :active="item === currentItem"
          @tabSelect="tabSelect(item)"
        >
        </f-project-tab>
      </template>
    </f-project-tabs>
  </div>
</template>

<script>
export default {
  props: {
    component: Object,
    handler: Object,
    currentItem: Object,
  },
  methods: {
    tabSelect(e) {
      this.$emit("tabselect", e);
    },
  },
  computed: {
    items() {
      //   return [];

      // console.log(this,
      //   Object.values(this.component.items).sort((a, b) => a.weight - b.weight)
      // );
      return (
        Object.values(this.component.items)
          // .map((item) => {

          //   return {
          //     title: item.title,
          //     weight: item.weight,
          //     icon: item.icon,
          //     active: item === this.currentItem,
          //     _key: item._key,
          //   };
          // })
          .sort((a, b) => a.weight - b.weight)
      );
    },
  },
};
</script>
<style lang="scss">
.f-console17-tabs {
  position: relative;
  display: inline;
}
</style>